module.exports = __webpack_public_path__ + "images/emoji/microscope.92958fcc4bc64ba9e958.png";


//////////////////
// WEBPACK FOOTER
// ./resources/images/emoji/microscope.png
// module id = 4fPC
// module chunks = 24